<section class="admin-portfolio-list-section">
    <sp-modal title="REVOKE INVITE" (confirm)="onRevoke()" #revokeModal confirmButtonText="Revoke">
      This action will revoke the invitation to <strong>{{invitation?.email}}</strong>.
    </sp-modal>
    
    <sp-modal title="RESEND INVITE" (confirm)="onResend()" #resendModal confirmButtonText="Resend">
      This action will resend the invitation to <strong>{{invitation?.email}}</strong>.
    </sp-modal>
    
    <sp-modal title="VIEW INVITE LINK" (confirm)="onViewLink()" #viewLinkModal
      confirmButtonText="Copy Invitation Link To Clipboard">
    
      <p class="text-muted margin-bottom-20">
        Invitation was last sent on {{invitation?.invitedOn | date: 'shortDate'}} to {{invitation?.fullName}}
        ({{invitation?.email}})
      </p>
    
      <div class="row margin-top-40">
        <div class="col-md-10 col-sm-12">
          <sp-clipboard-text-box 
            [value]="invitationUrl" 
            hint="Copy to clipboard">
          </sp-clipboard-text-box>
        </div>
      </div>
      
    </sp-modal>

    <header class="row page-header">
        <div class="col-sm-12">
          <sp-breadcrumbs>
              <sp-breadcrumb [text]="'Portfolios'" [routerLink]="['../']"></sp-breadcrumb>              
          </sp-breadcrumbs>

          <div class="row">
            <div class="col-sm-10">
              <a class="btn-back margin-bottom-10" [routerLink]="['../']"></a>
              <div class="titles-container">                
                <div class="title" *ngIf="(workspace$ | async)?.companyName">
                  {{(workspace$ | async)?.companyName}}
                </div>
                <div class="title" *ngIf="!(workspace$ | async)?.companyName">
                  {{(workspace$ | async)?.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
    </header>
    <div class="top top-buffer-20">
        <nav>
            <div class="nav nav-tabs" role="tablist">
                <a *ngFor="let tab of tabs"
                  [attr.aria-controls]="tab.name"
                  [attr.aria-selected]="tab.isActive"
                  [id]="tab.name"
                  role="tab"
                  data-bs-toggle="tab"
                  class="nav-item nav-link"
                  [ngClass]="{'active': tab.isActive}"
                  (click)="onTabClick(tab)">{{tab.title}}</a>
            </div>
        </nav>
    </div>
    <div class="tab-content">
      <div role="tabpanel" aria-labelledby="General" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabGeneral}" [id]="tabGeneral">
          <main>
            <sp-edit-workspace-details
              *ngIf="workspace$ | async"
              [workspace]="workspace$ | async"
              [userProfile]="userProfile$ | async"
              (deleteLogo)="onDeleteLogo($event)"
              (save)="onSave($event)"
              (saveLogo)="onSaveLogo()"
              (viewFinishedLoading)="generalTabLoaded()"
              (exportWorkspaceComponents)="onExportWorkspaceComponents($event)"
              (refreshPortfolioAnalytics)="onRefreshPortfolioAnalytics($event)"
            ></sp-edit-workspace-details>
        </main>
      </div>
      <div role="tabpanel" aria-labelledby="Properties" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabProperties}" [id]="tabProperties">
          <main>
            <sp-admin-edit-portfolio-properties
              #adminEditPortfolioProperties  
              [currentWorkspaceId]="workspaceId"        
              [workspaceProperties]="workspaceProperties"
              [companyName]="companyName"
              [workspaceName]="workspaceName"
              (deactivate)="onDeactivateProperty($event)"
              (reactivate)="onReactivateProperty($event)"
              (reassign)="onReassignProperty($event)"
              (duplicate)="onDuplicateProperty($event)"
              (clearCache)="onClearCache($event)"
            ></sp-admin-edit-portfolio-properties>
          </main>
      </div>
      <div role="tabpanel" aria-labelledby="Users" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabUsers}" [id]="tabUsers">
        <main>
          <sp-workspace-users-list-display
            #adminEditPortfolioUsers
            [workspaceUsers]="workspaceUsers"
            [workspaceProperties]="workspaceProperties"  
            [workspace]="workspace$ | async"
            [roles]="roles$ | async"
            (updateRole)="onUpdateRole($event)"
            (invite)="onInviteUser($event)"
            (deactivate)="onDeactivateUser($event)"
            (reactivate)="onReactivateUser($event)"
            (edit)="onEditUser($event)"
          ></sp-workspace-users-list-display>
        </main>
      </div>
      <div role="tabpanel" aria-labelledby="Invites" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabInvites}" [id]="tabInvites">
        <main>
          <sp-workspace-invites-list-display
              #adminPortfolioInvites 
              [invites]="workspaceInvites"
              (revoke)="onConfirmRevoke($event)"
              (resend)="onConfirmResend($event)"
              (viewLink)="onConfirmViewLink($event)">
          </sp-workspace-invites-list-display>
        </main>
      </div>
    </div>
</section>

<div [hidden]="!isLoading" [class.loading]="isLoading">Loading&#8230;</div>
